// extracted by mini-css-extract-plugin
export default {"wrapText":"background-type-option-module__wrapText--SWxBJ","minHeight":"background-type-option-module__minHeight--pdVqM"};